import React from "react";
import { FaChartLine, FaLightbulb, FaUsers, FaCog } from "react-icons/fa";

const BizwitResearch = () => {
  const blocks = [
    {
      icon: <FaChartLine className="text-gray-500 text-3xl" />,
      title: "Industry Expertise ",
      description:
        "Our team brings in-depth knowledge of ESG standards across various industries, helping you stay ahead of evolving regulations and market demands.",
    },
    {
      icon: <FaLightbulb className="text-gray-500 text-3xl" />,
      title: "Global Perspective, Local Insight",
      description:
        "While we operate on a global scale, our understanding of local market dynamics enables us to offer solutions that are both globally compliant and locally relevant",
    },
    {
      icon: <FaUsers className="text-gray-500 text-3xl" />,
      title: "Tailored Solutions",
      description:
        "We understand that every business has unique needs, and we customize our services to align with your organizational goals.",
    },
    {
      icon: <FaCog className="text-gray-500 text-3xl" />,
      title: "Sustainable Growth",
      description:
        "Our goal is to help you achieve sustainable, responsible growth that enhances your business's long-term value.",
    },
  ];

  return (
    <section className="p-8">
      <div className="font-poppins">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
          Why Choose Bizwit Research & Consulting LLP?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {blocks.map((block, index) => (
            <div
              key={index}
              className="flex items-start space-x-4 p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
            >
              <div className="flex-shrink-0">{block.icon}</div>
              <div>
                <h3 className="font-semibold text-xl text-gray-800 mb-2">
                  {block.title}
                </h3>
                <p className="text-gray-600">{block.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BizwitResearch;
